if (!customElements.get('ng-restock')) {
  customElements.define('ng-restock', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.email = this.form.elements.email;
      this.button = this.form.querySelector('button');
      this.status = this.querySelector('.ng-restock__status');
      this.success = this.querySelector('.ng-restock__success');
      this.successfulVariants ||= new Set();
      this.successMessages ||= new Map();
      this.successTitles ||= new Map();
      this.successTitle = this.success.querySelector('.ng-restock__success-title');
      this.successMessage = this.success.querySelector('.ng-restock__success-message');
      this.defaultSuccessMessage ||= this.successMessage.textContent;
      this.renderState();
      this.abort = new AbortController();
      this.form.addEventListener('submit', event => this.submit(event), { signal: this.abort.signal });
      this.email.addEventListener('invalid', () => this.email.setAttribute('aria-invalid', 'true'), { signal: this.abort.signal });
      this.email.addEventListener('input', () => { if (this.email.validity.valid) this.email.removeAttribute('aria-invalid'); }, { signal: this.abort.signal });
      this.variantChanged = event => {
        const variant = event.detail?.variant;
        const variants = this.closest('.m-main-product')?.querySelector('#productData');
        if (variant && variants && JSON.parse(variants.textContent).variants.some(item => String(item.id) === String(variant.id))) this.updateVariant(variant);
      };
      document.addEventListener('variant:changed', this.variantChanged, { signal: this.abort.signal });
      // The theme's pubsub also emits null for unavailable option combinations.
      if (window.MinimogEvents) {
        this.pubsubListener = variant => this.updateVariant(variant);
        this.unsubscribe = window.MinimogEvents.subscribe(`${this.dataset.productId}__VARIANT_CHANGE`, this.pubsubListener);
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.request?.abort();
      if (typeof this.unsubscribe === 'function') this.unsubscribe();
      this.initialized = false;
    }
    renderState() {
      const subscribed = this.successfulVariants.has(this.dataset.variantId);
      this.form.hidden = subscribed;
      this.success.hidden = !subscribed;
      this.successTitle.textContent = this.successTitles.get(this.dataset.variantId) || 'Subscription successful';
      this.successMessage.textContent = this.successMessages.get(this.dataset.variantId) || this.defaultSuccessMessage;
    }
    updateVariant(variant) {
      this.hidden = !variant || variant.available;
      const id = variant ? String(variant.id) : '';
      if (id === this.dataset.variantId) return;
      this.dataset.variantId = id;
      this.form.elements.variant_id.value = id;
      this.renderState();
      this.status.textContent = '';
      delete this.status.dataset.error;
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy || this.hidden || !this.dataset.variantId || this.successfulVariants.has(this.dataset.variantId)) return;
      if (!this.form.reportValidity()) return;
      const variantId = this.dataset.variantId;
      this.busy = true;
      this.button.disabled = true;
      this.button.textContent = 'Submitting…';
      this.form.setAttribute('aria-busy', 'true');
      this.status.textContent = '';
      this.request = new AbortController();
      const timeout = setTimeout(() => this.request.abort(), 20000);
      try {
        const response = await fetch(this.dataset.endpoint, {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: this.request.signal,
          body: JSON.stringify(Object.fromEntries(new FormData(this.form)))
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error || 'Please try again.');
        this.successfulVariants.add(variantId);
        this.successTitles.set(variantId, result.already_subscribed ? 'Already subscribed' : 'Subscription successful');
        this.successMessages.set(variantId, result.already_subscribed ? result.message : this.defaultSuccessMessage);
        if (this.dataset.variantId === variantId) {
          delete this.status.dataset.error;
          this.renderState();
          this.success.focus({ preventScroll: true });
        }
      } catch (error) {
        if (this.dataset.variantId === variantId) {
          this.status.textContent = error.name === 'AbortError' ? 'The request timed out. Please try again.' : error.message;
          this.status.dataset.error = 'true';
        }
      } finally {
        clearTimeout(timeout);
        this.busy = false;
        this.button.disabled = false;
        this.button.textContent = 'Notify me';
        this.form.removeAttribute('aria-busy');
      }
    }
  });
}
